<template>
    <div class="strategy-config">
        <div class="config-title">
            <h3>工具使用策略配置</h3>
        </div>
        <SearchCommon :formInline="formInline" :formList="formList" @onSearch="onSearch" @onResetBtn="onResetBtn" @enterSearch="enterSearch"></SearchCommon>
        <el-form class="config-form" ref="form" :model="form" label-position="left">
            <el-form-item>
                <div class="strategy-config-table">
                    <span class="config-tools">说明：</span>
                    <el-table border :data="form.tableData" :highlight-current-row="false" height="260px" style="width: 100%">
                        <el-table-column
                            type="index"
                            label="序号"
                            align="center"
                            width="60">
                        </el-table-column>
                        <el-table-column label="工具名称" align="center" width="220">
                            <template slot-scope="scope">
                                <el-form-item :prop="'tableData.' + scope.$index + '.id'" :rules="rules['id']">
                                    <el-select
                                    v-model="scope.row.id"
                                    collapse-tags
                                    size="small"
                                    clearable 
                                    filterable
                                    @change="changeCurrent($event)"
                                    placeholder="请选择">
                                        <el-option
                                        v-for="item in toolsOptions"
                                        :key="item.id"
                                        :disabled="item.occupiedFlag" 
                                        :label="item.toolName"
                                        :value="item.id">
                                            {{ item.toolName }}
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </template> 
                        </el-table-column>
                        <el-table-column prop="index" label="策略配置" align="center">
                            <template slot-scope="scope">
                               <div class="strategy-input">
                                    <dl v-for="(items, i) in Object.keys(scope.row.items)" :key="i">
                                        <el-form-item :prop="'tableData.' + scope.$index + '.items.' + items" :rules="{required:true,message:'不能为空',trigger:'blur'}">
                                            <span>{{ defaultSetProperty.find(item=>item.key==items).text }}</span>
                                            <el-input v-model="scope.row.items[items]" placeholder=""></el-input>
                                            <span>&nbsp;{{ defaultSetProperty.find(item=>item.key==items).unit }}</span>
                                        </el-form-item>
                                    </dl>
                               </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="操作"
                            align="center"
                            width="100">
                            <template slot-scope="scope">
                                <el-button style="color:#f56c6c;" type="text" @click="handleRemoveRow(scope.$index)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="add-btn-box">
                        <el-button size="small" icon="el-icon-plus" type="primary" @click="handleBatchAdd">批量操作</el-button>
                        <el-button size="small" icon="el-icon-plus" type="primary" @click="handleAdd">添加</el-button>
                    </div>
                </div>
                <span>说明：pdf合并、ofd合并、pdf排序，上传文件数量，建议配置2个</span>
            </el-form-item>
            <el-form-item class="config-btn">
                <el-button size="small" type="primary" @click="handleSaveEvent">保存</el-button>
                <el-button  size="small" @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>

        <!-- 批量操作 -->
        <batchAdd ref="batchAddDialog" :defaultSetProperty="defaultSetProperty" @batchAddSuccess="batchAddSuccess"></batchAdd>
    </div>
</template>
<script>
import SearchCommon from '../../../components/SearchCommon.vue';
import batchAdd from './components/batchAdd.vue';
export default {
    data() {
        return {
            formInline: {
                name: ''
            },
            formList: [
                { label: '工具名称', model: 'name', placeholder: '请输入工具名称', type: 'input' }
            ],
            form: {
                tableData: []
            },
            rules: {
                id:[
                    { required: true, message: '请选择工具', trigger: 'change' }
                ]
            },
            defaultSetProperty: [], // 默认设置的属性数据全部
            toolsOptions: [], // 工具名称下拉框数据
            copyNewData: [], // 备份数据
        }
    },
    components: {
        SearchCommon,
        batchAdd
    },
    mounted() {
        this.getToolsNameList();
        this.getSettableProperty();
        this.getList();
    },
    methods: {
        // 工具名称列表 暂时不用搜索
        getToolsNameList() {
            this.$store.dispatch('manage/public', {
                query: { name: '' }, 
                requestInterfaceName: 'getStrategyToolName'
            }).then(res=>{
                if(res.code == 0) {
                    this.toolsOptions = res.data;
                }
            })
        },
        // 获取可设置的属性（默认）
        getSettableProperty() {
            this.$store.dispatch('manage/public', {
                query: { }, 
                requestInterfaceName: 'getSetProperty'
            }).then(res=>{
                if(res.code == 0) {
                    this.defaultSetProperty = res.data;
                }
            })
        },
        // 获取列表
        getList() {
            this.$store.dispatch('manage/public', {
                query: { }, 
                requestInterfaceName: 'getStrategyToolList'
            }).then(res=>{
                if(res.code == 0) {
                    // 如果有值就取返回的数据
                    if(res.data.length > 0) {
                        this.form.tableData = res.data;
                    } else {
                        // 如果没有值就默认给一条
                        if (this.defaultSetProperty.length > 0) {
                            this.form.tableData.push({
                                id: "",
                                items: { ...this.getDynamicItems() }
                            });
                        }
                    }
                    // 备份
                    this.copyNewData = this.form.tableData.map(item=>item);
                }
            })
        },
        // 搜索
        onSearch() { 
            if(this.formInline.name == '') {
                this.form.tableData = this.copyNewData.map(copyItem=>copyItem);
                return;
            }

            const searchResult = this.toolsOptions.filter(item=>item.toolName.toLocaleLowerCase().indexOf(this.formInline.name.toLocaleLowerCase())>-1);
            if(searchResult.length > 0) {
                this.form.tableData = this.copyNewData.filter(item => searchResult.some(result => result.id === item.id));
            } else {
                this.form.tableData = [];
            }
        },
        // 清空
        onResetBtn() {
            this.formInline = {
                name: ''
            }
            this.form.tableData = this.copyNewData.map(copyItem=>copyItem);
        },
        // 回车
        enterSearch() {
            this.onSearch();
        },
       
        // 工具名称选择下拉框
        changeCurrent(item){
            this.$store.dispatch('manage/public', {
                query: item, 
                requestInterfaceName: 'getToolSetProperty'
            }).then(res=>{
                if(res.code == 0) {
                    this.form.tableData.forEach(childs=>{
                        if(childs.id == item) {
                            childs.items = { ...this.changePropertyData(res.data)}
                        }
                    })
                }
            })
        },
        changePropertyData(data) {
            const items = {};
            data.forEach(eles => {
                items[eles.key] = "";
            });
            return items;
        },

        // 批量操作
        handleBatchAdd() {
            this.$nextTick(()=>{
                this.$refs.batchAddDialog.dialogVisible = true;
            })
        },
        // 批量操作成功回调
        batchAddSuccess() {
            // 刷新列表 
            this.$store.dispatch('manage/public', {
                query: { }, 
                requestInterfaceName: 'getStrategyToolList'
            }).then(res=>{
                if(res.code == 0) {
                    this.form.tableData = res.data;
                    // 获取下拉框的数据
                    this.getToolsNameList();

                    // 备份
                    this.copyNewData = this.form.tableData.map(item=>item);
                }
            })
        },
        // 添加
        handleAdd() {
            if (this.defaultSetProperty.length > 0) {
                this.form.tableData.push({
                    id: "",
                    items: { ...this.getDynamicItems() }
                });
            }
        },
        getDynamicItems() {
            const items = {};
            this.defaultSetProperty.forEach(eles => {
                items[eles.key] = "";
            });
            return items;
        },
        // 删除
        handleRemoveRow(index) {
            this.$confirm('是否确认删除该数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.form.tableData.splice(index, 1);
            })
        },
        
        // 保存
        handleSaveEvent() {
            this.$refs.form.validate(valid=>{
                if(valid){
                    this.$store.dispatch('manage/public', {
                        query: this.form.tableData, 
                        requestInterfaceName: 'strategySave'
                    }).then(res=>{
                        if(res.code == 0) {
                            this.$message.success('保存成功');
                            // 获取下拉框的数据
                            this.getToolsNameList();
                        } else {
                            this.$message.error(res.message);
                        }
                    })
                } else {
                    return false
                }
            })
        },
        // 取消
        cancel() {
            this.form.tableData = this.copyNewData.map(copyItem=>copyItem);
        }
    }
}
</script>
<style lang="less" scoped>
.strategy-config {
    padding: 20px;
    box-sizing: border-box;
    .config-title {
        margin-bottom: 20px;
        h3 {
            margin: 0px;
            padding: 0px;
            position: relative;
            &::before {
                content: '';
                width: 5px;
                height: 20px;
                background: #409EFF;
                position: absolute;
                left: 0px;
                top: 0px;
            }
            padding-left: 15px;
        }
    }
    .config-form {
        .el-form-item {
            margin-bottom: 0px;
        }
    }
   
    .strategy-config-table {
        border: 1px solid rgba(228, 228, 228, 1);
        padding: 10px 20px 20px 20px;
        box-sizing: border-box;
        .config-tools {
            color: #333;
            font-weight: 400;
            font-size: 14px;
        }
        /deep/ .el-form-item__error {
            position:relative;
            left:-10%;
        }
        /deep/ .el-table__cell {
            padding: 4px 0;
        }
        /deep/ .has-gutter {
            tr {
                th {
                    color: #333;
                    background: #e4e4e4;
                }
            }
        }
        /deep/ .el-table__body tr:hover{
            td.el-table__cell {
                background: #fff;
            }
        }
        .strategy-input {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            dl {
                width: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 0;
                margin: 0;
                >span:first-child {
                    min-width: 200px;
                    text-align: right;
                }
                >span:last-child {
                    width: 100px;
                    text-align: left;
                }
                /deep/ .el-input {
                    width: 70px;
                    .el-input__inner {
                        height: 30px;
                        line-height: 30px;
                        padding: 0 10px;
                    }
                }
            }
            dl:first-child {
                margin-bottom: 10px;
            }
        }
        .add-btn-box {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 20px;
        }
    }
    .config-btn {
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>